import { NodeData } from '../../../type';

export interface NodeRequestConfig {
  nodeData: NodeData;
  changes: {
    name: string | number | undefined;
  };
}

export const NODE_ADDED = 'nodeAdded';
